import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { getInvoiceSubmittalDetails } from '~bank-invoices/service/invoiceSubmittalDetails'

export const DetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id`,
    beforeLoad: ({ params }) => {
      if ('id' in params) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loader: async ({ context: { id } }) => await getInvoiceSubmittalDetails({ id }),
    component: lazyRouteComponent(() => import('./InvoiceDetails'))
  })
